import {reactive} from 'vue';
import {StorageService} from "@/services/storageService.ts";

export interface AppNotification {
    title: string;
    body: string;
    notificationId: string;
    type: string;
    subject?: string;
    message?: string;
    actionId?: string;
    biometricsRequired?: boolean;
    mustBeInStore?: boolean;
    timeoutSec?: number;
    expiresAt?: string;
}

export const notificationState = reactive({
    pendingNotification: null as AppNotification | null,
    activeNotification: null as AppNotification | null,
});

export async function initNotificationStore() {
    const [pending, active] = await Promise.all([
        StorageService.Get<AppNotification>("PENDING_NOTIFICATION"),
        StorageService.Get<AppNotification>("ACTIVE_NOTIFICATION"),
    ]);

    if (pending) {
        notificationState.pendingNotification = pending;
    }

    if (active) {
        notificationState.activeNotification = active;
    }
}

export async function setActiveNotification(notification: AppNotification) {
    notificationState.activeNotification = notification;
    await StorageService.Set("ACTIVE_NOTIFICATION", notification);
}

export async function clearActiveNotification() {
    notificationState.activeNotification = null;
    await StorageService.Remove("ACTIVE_NOTIFICATION");
}

export async function setPendingNotification(notification: AppNotification | null) {
    notificationState.pendingNotification = notification;
    if (notification) {
        await StorageService.Set("PENDING_NOTIFICATION", notification);
    } else {
        await StorageService.Remove("PENDING_NOTIFICATION");
    }
}

export async function clearPendingNotification() {
    notificationState.pendingNotification = null;
    await StorageService.Remove("PENDING_NOTIFICATION");
}